(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9296],{

/***/ 19334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SectionTryForFree_SectionTryForFree; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/SectionTryForFree.js





const Title = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__title",
        children: children
    });
};
Title.propTypes = {
    children: prop_types.node.isRequired
};
const Action = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__action",
        children: children
    });
};
Action.propTypes = {
    children: prop_types.node.isRequired
};
const SectionTryForFree = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: "section-try-for-free",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    utility: {
                        position: {
                            position: "relative",
                            zIndex: 1
                        }
                    },
                    children: children
                })
            })
        })
    });
};
SectionTryForFree.propTypes = {
    children: prop_types.node.isRequired
};
SectionTryForFree.Title = Title;
SectionTryForFree.Action = Action;
/* harmony default export */ var SectionTryForFree_SectionTryForFree = (SectionTryForFree);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/index.js



/***/ }),

/***/ 97849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Item; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Tabs/Grid.js






const TabCol = (param)=>/*#__PURE__*/ {
    let { className , cell ="" , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , ...props } = param;
    return (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
        className: (0,classes/* classes */.S)(cell, ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props,
        role: "presentation"
    });
};
TabCol.propTypes = {
    cell: prop_types.string,
    ...Grid/* Col.propTypes */.JX.propTypes
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Tabs/Title.js









const TabTitle = (param)=>{
    let { Tag =Link/* default */.Z , tabType =1 , tabID ="" , isAnchor =false , active =false , className , px =true , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , ...props } = param;
    const ResultTag = active ? "span" : Tag;
    const anchor = isAnchor ? {
        id: "".concat(tabID, "-tab"),
        href: "#".concat(tabID)
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultTag, {
        "data-toggle": "tab",
        role: "tab",
        "aria-controls": tabID,
        "aria-selected": active,
        className: (0,classes/* classes */.S)("tabs-v".concat(tabType, "__item"), active && "tabs-v".concat(tabType, "__item--active"), ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)((0,pureProps/* deepMergeProps */.p)(px ? {
            md: {
                px: 10
            }
        } : {}, (0,pureProps/* default */.Z)(spacing))), className),
        ...anchor,
        ...props
    });
};
TabTitle.propTypes = {
    Tag: prop_types.elementType,
    tabID: prop_types.string,
    tabType: (0,prop_types.oneOf)([
        1,
        2
    ]),
    isAnchor: prop_types.bool,
    active: prop_types.bool,
    px: prop_types.bool,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    className: prop_types.string
};
/* harmony default export */ var Title = (TabTitle);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Tabs/Item.js





const TabItem = (param)=>{
    let { tabType =1 , active =false , tabClassName , cell ="medium-shrink" , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabCol, {
        className: tabClassName,
        cell: cell,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
            tabType: tabType,
            active: active,
            ...props
        })
    });
};
TabItem.propTypes = {
    cell: prop_types.string,
    tabType: (0,prop_types.oneOf)([
        1,
        2
    ]),
    tabClassName: prop_types.string,
    active: prop_types.bool,
    ...Title.propTypes
};
/* harmony default export */ var Item = (TabItem);


/***/ }),

/***/ 77739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Tabs_Tabs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Tabs/Tabs.js






const Tabs = (param)=>{
    let { tabsID ="" , tabsType =1 , isBorderBottom =true , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        id: tabsID,
        className: (0,classes/* classes */.S)("tabs-v".concat(tabsType), isBorderBottom && "tabs-v".concat(tabsType, "--border-bottom"), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        role: "tablist",
        ...props,
        children: children
    });
};
Tabs.propTypes = {
    isBorderBottom: prop_types.bool,
    tabsType: (0,prop_types.oneOf)([
        1,
        2
    ]),
    tabsID: prop_types.string,
    className: prop_types.string,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Tabs_Tabs = (Tabs);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Tabs/index.js



/***/ }),

/***/ 51192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UList_UList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/UList/UList.js







const UListItem = (param)=>{
    let { bulletColor , size , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: (0,classes/* classes */.S)("li", size && "text-".concat(size), bulletColor && "li--bullet-color-".concat(bulletColor), ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props,
        children: children
    });
};
UListItem.propTypes = {
    size: props_sx/* fontSizePropTypes */.Gk,
    bulletColor: (0,prop_types.oneOf)([
        "orange",
        "dotmatics-7",
        "black--custom-1"
    ]),
    className: prop_types.string,
    children: prop_types.node.isRequired,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
const UList = (param)=>{
    let { type ="default" , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (0,classes/* classes */.S)("ul", "ul-".concat(type), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        children: children
    });
};
UList.propTypes = {
    type: (0,prop_types.oneOf)([
        "default",
        "pros",
        "cons"
    ]),
    className: prop_types.string,
    children: prop_types.node.isRequired,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
UList.Item = UListItem;
/* harmony default export */ var UList_UList = (UList);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/UList/index.js



/***/ }),

/***/ 12985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const ContentContainer = (param)=>{
    let { mx =false , px =false , my =false , py =false , sm ="" , md ="" , lg ="" , center =false , containerClassName ="" , className ="" , isFluid =false , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
        className: containerClassName,
        isFluid: isFluid,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
            mx: mx,
            px: px,
            my: my,
            py: py,
            className: className,
            center: center,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                sm: sm,
                md: md,
                lg: lg,
                children: children
            })
        })
    });
};
ContentContainer.propTypes = {
    mx: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    px: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    my: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    py: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    containerClassName: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    isFluid: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentContainer);


/***/ }),

/***/ 27276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q0": function() { return /* reexport */ BlockQuote_BlockQuote; },
  "_w": function() { return /* reexport */ Thumb; },
  "ZP": function() { return /* reexport */ Slider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/BlockQuote/BlockQuote.js




const BlockQuote = (param)=>{
    let { author , jobTitle ="" , institution , active =false , isBorderNone =false , className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,classes/* classes */.S)("bq__item", active && "bq__item--active", isBorderNone && "bq__item--border-none", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bq__item-message",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bq__item-author",
                children: author
            }),
            jobTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bq__item-job-title",
                children: jobTitle
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bq__item-institution",
                children: institution
            })
        ]
    });
};
BlockQuote.propTypes = {
    author: prop_types.string.isRequired,
    jobTitle: prop_types.string,
    institution: prop_types.string.isRequired,
    active: prop_types.bool,
    isBorderNone: prop_types.bool,
    className: prop_types.string,
    children: prop_types.node.isRequired
};
/* harmony default export */ var BlockQuote_BlockQuote = (BlockQuote);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/BlockQuote/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/BlockQuote/Thumb.js






const BlockQuoteThumb = (param)=>{
    let { className ="" , src , alt ="" , active =false , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
        ...props,
        md: "auto",
        className: (0,classes/* classes */.S)("bq__item-thumb", active && "bq__item-thumb--active", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
            utility: {
                align: {
                    items: "center"
                }
            },
            className: "bq__item-thumb-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: src,
                    alt: alt
                })
            })
        })
    });
};
BlockQuoteThumb.propTypes = {
    src: prop_types.string.isRequired,
    alt: prop_types.string,
    active: prop_types.bool,
    className: prop_types.string
};
/* harmony default export */ var Thumb = (BlockQuoteThumb);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/BlockQuote/Slider.js






const Head = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        id: "BlockQuoteHead",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
            children: children
        })
    });
};
Head.propTypes = {
    children: prop_types.node.isRequired
};
const Thumbs = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        mx: true,
        id: "BlockQuoteThumbs",
        spacing: {
            mb: 15
        },
        children: children
    });
};
Thumbs.propTypes = {
    children: prop_types.node.isRequired
};
const Footer = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
            children: children
        })
    });
};
Footer.propTypes = {
    children: prop_types.node.isRequired
};
const BlockQuoteSlider = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        spacing: {
            pb: 20
        },
        className: "bq",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
            lg: 10,
            center: true,
            children: children
        })
    });
};
BlockQuoteSlider.propTypes = {
    children: prop_types.node.isRequired
};
BlockQuoteSlider.Head = Head;
BlockQuoteSlider.Thumbs = Thumbs;
BlockQuoteSlider.Footer = Footer;
/* harmony default export */ var Slider = (BlockQuoteSlider);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/r1/molecules/BlockQuote/index.js
// TODO: import to this file is deprecated!






/***/ }),

/***/ 10819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10334);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42866);
/* harmony import */ var _UList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51192);
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6949);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67924);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18981);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2349);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(23720);












const Title = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        Tag: "h2",
        sx: {
            fontSize: "m",
            fontColor: "black"
        },
        spacing: {
            mb: 4
        },
        ...props
    });
};
Title.propTypes = {
    ..._Heading__WEBPACK_IMPORTED_MODULE_4__/* ["default"].propTypes */ .Z.propTypes
};
const FeaturesBlockItem = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
        spacing: {
            mb: 4
        },
        children: children
    });
};
FeaturesBlockItem.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_11__.node.isRequired
};
const FeaturesBlock = (param)=>{
    let { title , imgSrc , imgClassName ="" , isImgFirst =true , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_8__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_10__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_9__/* .spacingProps */ .tF
    } , className ="" , children  } = param;
    const imgSpacingProps = isImgFirst ? {
        lg: {
            mr: 12
        }
    } : {
        lg: {
            ml: 12
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_7__/* .classes */ .S)(...(0,_props_utility__WEBPACK_IMPORTED_MODULE_8__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_10__/* .sxClassName */ .ZA)(sx), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_9__/* .spacingClassName */ .RB)(spacing), className),
        children: isImgFirst ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                    lg: 6,
                    spacing: {
                        mb: 4,
                        lg: {
                            mb: 0
                        }
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        sx: {
                            textAlign: "center"
                        },
                        spacing: imgSpacingProps,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            src: imgSrc,
                            className: imgClassName
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                    lg: 6,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            children: children
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                    lg: 6,
                    className: "small-order-2 large-order-1",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UList__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            children: children
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                    lg: 6,
                    spacing: {
                        mb: 4,
                        lg: {
                            mb: 0
                        }
                    },
                    className: "small-order-1 large-order-2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        sx: {
                            textAlign: "center"
                        },
                        spacing: imgSpacingProps,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            src: imgSrc,
                            className: imgClassName
                        })
                    })
                })
            ]
        })
    });
};
FeaturesBlock.propTypes = {
    imgSrc: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired,
    imgClassName: prop_types__WEBPACK_IMPORTED_MODULE_11__.string,
    isImgFirst: prop_types__WEBPACK_IMPORTED_MODULE_11__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_11__.node.isRequired,
    className: prop_types__WEBPACK_IMPORTED_MODULE_11__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_11__.node.isRequired,
    utility: _props_utility__WEBPACK_IMPORTED_MODULE_8__/* .utilityPropTypes */ .pQ,
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_10__/* .sxPropTypes */ .I1,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_9__/* .spacingPropTypes */ .Xj
};
FeaturesBlock.Item = FeaturesBlockItem;
/* harmony default export */ __webpack_exports__["Z"] = (FeaturesBlock);


/***/ }),

/***/ 53381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export context */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Tabs_Item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97849);




const context = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({
    active: null,
    setActive: ()=>{}
});
const SmartTabs = (param)=>{
    let { initialActiveTab , children  } = param;
    const [active, setActive] = react__WEBPACK_IMPORTED_MODULE_1__.useState(initialActiveTab);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(context.Provider, {
        value: {
            active,
            setActive
        },
        children: children
    });
};
SmartTabs.propTypes = {
    initialActiveTab: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node
};
const SmartTab = (param)=>{
    let { id , Component =_Tabs_Item__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z , ...props } = param;
    const { active , setActive  } = react__WEBPACK_IMPORTED_MODULE_1__.useContext(context);
    const openTab = react__WEBPACK_IMPORTED_MODULE_1__.useCallback((event)=>{
        event.preventDefault();
        setActive(id);
    }, [
        id,
        setActive
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
        active: id === active,
        onClick: openTab,
        ...props,
        id: id
    });
};
SmartTab.propTypes = {
    id: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    Component: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_3__.elementType
    ]),
    cell: prop_types__WEBPACK_IMPORTED_MODULE_3__.string
};
const SmartTabBody = (param)=>/*#__PURE__*/ {
    let { id , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(context.Consumer, {
        children: (param)=>{
            let { active  } = param;
            return active === id && children;
        }
    });
};
SmartTabBody.propTypes = {
    id: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node
};
const MountedTabBody = (param)=>/*#__PURE__*/ {
    let { id , children , Component  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(context.Consumer, {
        children: (param)=>/*#__PURE__*/ {
            let { active  } = param;
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                style: {
                    display: active === id ? "block" : "none"
                },
                children: children
            });
        }
    });
};
MountedTabBody.propTypes = {
    id: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node,
    Component: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_3__.elementType
    ]).isRequired
};
SmartTabBody.Mounted = MountedTabBody;
SmartTabs.Tab = SmartTab;
SmartTabs.TabBody = SmartTabBody;
/* harmony default export */ __webpack_exports__["Z"] = (SmartTabs);


/***/ }),

/***/ 93890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports MetaTwitter, MetaOGP */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84154);





const Robots = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "robots",
            content: content
        })
    });
};
Robots.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Author = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "author",
            content: content
        })
    });
};
Author.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Canonical = (param)=>/*#__PURE__*/ {
    let { href  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "canonical",
            href: href
        })
    });
};
Canonical.propTypes = {
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
};
const CanonicalAlternate = (param)=>/*#__PURE__*/ {
    let { type ="text/html" , hrefLang , href , title =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "alternate",
            type: type,
            hrefLang: hrefLang,
            href: href,
            title: title
        })
    });
};
CanonicalAlternate.propTypes = {
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const MetaTwitter = (param)=>{
    let { card ="" , title ="" , description ="" , site ="" , image ="" , creator ="" , isImageBaseUrl =false  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            card && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: card
            }),
            site && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: site
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: "".concat(baseUrl).concat(image)
            }),
            creator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: creator
            })
        ]
    });
};
MetaTwitter.propTypes = {
    card: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    site: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    creator: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool
};
const MetaOGP = (param)=>{
    let { isImageBaseUrl =false , title ="" , description ="" , locale ="" , type ="" , url ="" , image ="" , imageSecureUrl ="" , siteName ="" , articlePublisher =""  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            locale && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: locale
            }),
            type && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "".concat(baseUrl).concat(image)
            }),
            imageSecureUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: "".concat(baseUrl).concat(imageSecureUrl)
            }),
            siteName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: siteName
            }),
            articlePublisher && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:publisher",
                content: articlePublisher
            })
        ]
    });
};
MetaOGP.propTypes = {
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    locale: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    url: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    imageSecureUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    siteName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    articlePublisher: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const PageMeta = (param)=>{
    let { title ="" , description ="" , children =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            }),
            children
        ]
    });
};
const CustomHead = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: children
    });
};
CustomHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
PageMeta.Robots = Robots;
PageMeta.Custom = CustomHead;
PageMeta.Canonical = Canonical;
PageMeta.CanonicalAlternate = CanonicalAlternate;
PageMeta.Author = Author;
PageMeta.Twitter = MetaTwitter;
PageMeta.OGP = MetaOGP;
PageMeta.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
/* harmony default export */ __webpack_exports__["ZP"] = (PageMeta);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ })

}]);